import React, { useContext } from 'react';
import style from './Tabs.module.less';
import PropTypes from 'prop-types';
import AppLink from '../../links/AppLink';
import { tabInfoPropType, isSeasonalNavButtonActive } from '../util';
import { Image, SvgIcon } from 'edcom-ui';
import BrainzyAccess from '../BrainzyAccess';
import AccountContext from '../../../services/AccountContext';

export const NavItem = ({ tabInfo }) => {
  const { name, hasDropdown, seasonalInfo } = tabInfo;

  return (
    <div className={style.tabItem}>
      {seasonalInfo && (
        <Image
          className={style.tabItemIcon}
          src={seasonalInfo.icon}
          alt=""
          aria-hidden
        />
      )}
      <span>{name}</span>
      <div className={style.arrow}>
        {hasDropdown && <SvgIcon name="angleRight" aria-hidden />}
      </div>
    </div>
  );
};

NavItem.propTypes = {
  tabInfo: tabInfoPropType.isRequired,
};

export default function Tabs({ navInfo, onClick, hideMenu }) {
  const { ready, memberId } = useContext(AccountContext);
  const isLoggedIn = ready && memberId;

  return (
    <>
      <div className={style.tabs}>
        <ul className={style.itemsContainer}>
          {navInfo.map(tab => {
            const { seasonalInfo, urlName } = tab;

            // Skip inactive seasonal links
            if (seasonalInfo && !isSeasonalNavButtonActive(seasonalInfo)) {
              return null;
            }

            // Seasonal links can include slashes (e.g. "/halloween/") while regular buttons don't (e.g. "worksheet")
            const buttonUrl = urlName.includes('/') ? urlName : `/${urlName}/`;

            return (
              <li key={tab.urlName} className={style.tabItems}>
                {/* If a tab does not have a dropdown menu, clicks it will lead to its page ('/exercise/' for example)
              directly; otherwise clicks on it will not go to its page but go to a content menu page */}
                {!tab.hasDropdown ? (
                  <AppLink href={buttonUrl} onClick={hideMenu}>
                    <NavItem tabInfo={tab} />
                  </AppLink>
                ) : (
                  <button
                    className={style.openContentMenuButton}
                    onClick={() => onClick(tab.urlName)}
                    type="button"
                    aria-label={`${tab.name} menu`}
                  >
                    <NavItem tabInfo={tab} />
                  </button>
                )}
              </li>
            );
          })}
        </ul>
        <AppLink
          href="/resources/"
          className={style.browseAll}
          onClick={hideMenu}
        >
          <span>Browse Learning Library</span>
          <SvgIcon name="arrowRight" className={style.arrowRight} aria-hidden />
        </AppLink>
      </div>
      {isLoggedIn && <BrainzyAccess isMobile />}
    </>
  );
}

Tabs.propTypes = {
  navInfo: PropTypes.arrayOf(tabInfoPropType).isRequired,
  onClick: PropTypes.func.isRequired,
  hideMenu: PropTypes.func.isRequired,
};
